import { Injectable } from '@angular/core';
import * as bundleLineInActions from './bundle-line-in-db.actions';
import * as bundleLineInSelectors from './bundle-line-in-db.selectors';

import { select, Store } from '@ngrx/store';

import { AppNotificationUtilClass, BundleLineInDataProvider, InputAppDataService } from '@monorepo/services';
import { TInputAppState } from '../reducer';
import {
  TREQUEST_SAVE_EVENT_BUNDLE_LINE_IN,
  TREQUEST_BUNDLE_LINE_IN_ACTIVITY_LOG,
  TREQUEST_BUNDLE_LINE_IN_TRANSACTION_LOG,
  TREQUEST_GET_BUNDLE_LINE_IN_TAG,
  TREQUEST_RESTORE_COUNT_BUNDLE_LINE_IN,
  TREQUEST_BUNDLE_LINE_IN_AVAILABLE_WIP,
  TREQUEST_UndoValidation,
} from '@monorepo/types';
import { finalize, switchMap, take } from 'rxjs/operators';
import { from } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class BundleLineInFacade {
  constructor(
    private inputAppDataService: InputAppDataService,
    private store: Store<TInputAppState>,
    private appNotificationUtilClass: AppNotificationUtilClass,
    private bundleLineInDataProvider: BundleLineInDataProvider,
  ) {}

  getBundleLineInAvailableWip(payload: TREQUEST_BUNDLE_LINE_IN_AVAILABLE_WIP) {
    return from(this.appNotificationUtilClass.presentLoading('Loading...')).pipe(
      take(1),
      switchMap((loaderEl) => {
        return this.bundleLineInDataProvider
          .getBundleLineInAvailableWip(payload)
          .pipe(finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)));
      }),
    );
  }

  getBundleLineInTagDetails(payload: TREQUEST_GET_BUNDLE_LINE_IN_TAG) {
    return from(this.appNotificationUtilClass.presentLoading('Loading...')).pipe(
      take(1),
      switchMap((loaderEl) => {
        return this.bundleLineInDataProvider
          .getBundleLineInTagDetails(payload)
          .pipe(finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)));
      }),
    );
  }

  saveBundleLineInEvent(payload: TREQUEST_SAVE_EVENT_BUNDLE_LINE_IN) {
    return from(this.appNotificationUtilClass.presentLoading('Loading...')).pipe(
      take(1),
      switchMap((loaderEl) => {
        return this.bundleLineInDataProvider
          .saveBundleLineInEvent(payload)
          .pipe(finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)));
      }),
    );
  }

  // Same WIP undo validation the per-piece line-in flow uses.
  validateBundleLineInUndo(payload: TREQUEST_UndoValidation) {
    return from(this.appNotificationUtilClass.presentLoading('Loading...')).pipe(
      take(1),
      switchMap((loaderEl) => {
        return this.inputAppDataService
          .validateUndo(payload)
          .pipe(finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)));
      }),
    );
  }

  fetchTransactionLogInfo(payload: TREQUEST_BUNDLE_LINE_IN_TRANSACTION_LOG) {
    this.store.dispatch(new bundleLineInActions.GetTransactionLog(payload));
  }

  fetchActivityLogInfo(payload: TREQUEST_BUNDLE_LINE_IN_ACTIVITY_LOG) {
    this.store.dispatch(new bundleLineInActions.GetActivityLog(payload));
  }

  fetchRestoreCountInfo(payload: TREQUEST_RESTORE_COUNT_BUNDLE_LINE_IN) {
    this.store.dispatch(new bundleLineInActions.GetRestoreCount(payload));
  }

  getTransactionLog() {
    return this.store.pipe(select(bundleLineInSelectors.getTransactionLogInfo));
  }

  getActivityLog() {
    return this.store.pipe(select(bundleLineInSelectors.getActivityLogInfo));
  }

  getRestoreCount() {
    return this.store.pipe(select(bundleLineInSelectors.getRestoreCount));
  }
}

export type TTransactionLogBundleLineInInfo = ReturnType<BundleLineInFacade['getTransactionLog']>;
export type TActivityLogBundleLineInInfo = ReturnType<BundleLineInFacade['getActivityLog']>;
